// extracted by mini-css-extract-plugin
var _1 = "iIjFOB9xyW7IVp_jG6Db";
var _2 = "iIjFOB9xyW7IVp_jG6Db";
var _3 = "SE3MP96NxypERXP7aHo1";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "title" }
